/** Reference-matched preset pictograms, not scaled-down editable graphs.
 * These illustrations deliberately do not change the preset's timing data.
 */
const CURVE_PATHS: Record<string, string> = {
  Montage: 'M7 63 C22 63 28 58 36 44 C43 32 48 23 55 23 C65 23 68 46 73 69 C77 87 77 101 84 101 C91 101 92 63 100 63 H117',
  Hero: 'M6 62 C19 62 26 32 39 32 C49 32 51 47 54 73 C56 91 57 96 62 96 C70 96 68 32 81 32 C94 32 99 60 117 62',
  Bullet: 'M5 32 H35 C49 32 40 98 61 98 C81 98 72 32 88 32 H119',
  'Jump cut': 'M5 94 H33 C47 94 43 26 59 26 C75 26 69 94 90 94 H119',
  'Flash in': 'M7 31 H44 C67 31 66 62 92 62 H117',
  'Flash out': 'M7 62 H46 C69 62 68 31 94 31 H117',
}

export function SpeedPresetIcon({ name }: { name: string }) {
  if (name === 'None') return <svg viewBox="0 0 124 124" className="h-full w-full text-muted-foreground" aria-hidden="true" focusable="false" data-speed-preset-icon={name}>
    <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
      <circle cx="62" cy="62" r="22" />
      <path d="M46.5 46.5 L77.5 77.5" />
    </g>
  </svg>

  if (name === 'Custom') return <svg viewBox="0 0 124 124" className="h-full w-full text-primary" aria-hidden="true" focusable="false" data-speed-preset-icon={name}>
    <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
      <path d="M33 38 H41 M51 38 H90 M33 62 H58 M68 62 H90 M33 86 H73 M83 86 H90" />
      <circle cx="46" cy="38" r="4" /><circle cx="63" cy="62" r="4" /><circle cx="78" cy="86" r="4" />
    </g>
  </svg>

  const curve = CURVE_PATHS[name]
  if (!curve) throw new Error(`Unknown speed preset icon: ${name}`)
  return <svg viewBox="0 0 124 124" className="h-full w-full text-primary" aria-hidden="true" focusable="false" data-speed-preset-icon={name}>
    <g fill="none" stroke="currentColor" strokeWidth="1.5" strokeDasharray="7 5" className="text-muted-foreground/30" data-testid="speed-preset-guides">
      <path d="M0 30 H124 M0 62 H124 M0 94 H124" />
    </g>
    <path d={curve} fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-testid="speed-preset-curve" />
  </svg>
}
